// https://github.com/ethereum/EIPs/blob/master/EIPS/eip-4844.md#parameters

export const versionedHashVersionKzg = 1
